import { compareVersions, currentTimeMillis, Module, RuntimeVersion } from '@nu-art/ts-common';
import { apiWithQuery } from '../core/typed-api.js';
import { ApiDef_ServerInfo } from '@nu-art/thunderstorm-shared/server-info/api';
import { Default_ServerInfoNodePath } from '@nu-art/thunderstorm-shared';
import { ModuleFE_FirebaseListener } from '@nu-art/firebase-frontend/ModuleFE_FirebaseListener/ModuleFE_FirebaseListener';
import { StorageKey } from '../modules/ModuleFE_LocalStorage.js';
export const StorageKey_ServerVersion = new StorageKey('server-version');
// const dispatch_OnServerInfoUpdated = new ThunderDispatcher<OnServerInfoUpdatedListener, '__onServerInfoUpdated'>('__onServerInfoUpdated');
class ModuleFE_ServerInfo_Class extends Module {
    v1;
    serverInfoFirebaseListener;
    constructor() {
        super();
        this.v1 = {
            getServerInfo: apiWithQuery(ApiDef_ServerInfo.v1.getServerInfo),
            // @ts-ignore // to be used only by Jenkins
            updateServerInfoState: undefined,
        };
    }
    startListening() {
        if (this.serverInfoFirebaseListener) {
            this.logWarning(`Trying to start listening on --- ${Default_ServerInfoNodePath} --- but the listener already exists.`);
            return;
        }
        this.serverInfoFirebaseListener = ModuleFE_FirebaseListener
            .createListener(Default_ServerInfoNodePath)
            .startListening(this.onServerInfoDataChanged);
    }
    stopListening() {
        this.logDebug(`Stop listening on ${Default_ServerInfoNodePath}`);
        this.serverInfoFirebaseListener?.stopListening();
        this.serverInfoFirebaseListener = undefined;
    }
    onServerInfoDataChanged = async (snapshot) => {
        const rtdbServerInfoData = snapshot.val();
        if (!rtdbServerInfoData)
            return this.logInfo(`Did not receive any ServerInfo via firebase listener`, '');
    };
    Version = {
        getAppVersion: () => {
            let version = RuntimeVersion();
            if (!version) {
                this.logWarning(`Couldn't find a version-app.json file to get the code version from.`, '');
                version = '0.0.0';
            }
            this.logInfo(`Code version: ${version}`, '');
            return version;
        },
        getLatestVersion: () => {
            const version = StorageKey_ServerVersion.get() || '0.0.0';
            this.logInfo(`Server version: ${version}`, '');
            return version;
        },
        shouldUpdateVersion: () => {
            const lastVersion = this.Version.getLatestVersion();
            const codeVersion = this.Version.getAppVersion();
            return compareVersions(codeVersion, lastVersion) === 1;
        }
    };
    Update = {
        updateAndRefreshPage: () => {
            const url = new URL(window.location.href);
            url.searchParams.set('update', currentTimeMillis() + '');
            window.location.assign(url.toString());
        }
    };
}
export const ModuleFE_ServerInfo = new ModuleFE_ServerInfo_Class();
//# sourceMappingURL=ModuleFE_ServerInfo.js.map